var _dec, _class, _RatingIcon;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { IconStarSolid, IconStarLightSolid } from '@instructure/ui-icons';
import { requestAnimationFrame } from '@instructure/ui-dom-utils';
import { Transition } from '@instructure/ui-motion';
import { withStyle } from '@instructure/emotion';
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
import { allowedProps } from "./props.js";
/**
---
parent: Rating
id: Rating.Icon
---
**/
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
let RatingIcon = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_RatingIcon = class RatingIcon extends Component {
  constructor(props) {
    super(props);
    this.ref = null;
    this._timeouts = [];
    this._animation = void 0;
    this.makeStyleProps = () => {
      return {
        filled: this.state.filled
      };
    };
    this.fill = () => {
      this._animation = requestAnimationFrame(() => {
        this.setState({
          filled: true
        });
      });
    };
    this.state = {
      filled: props.filled && !props.animateFill
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props, this.makeStyleProps());
    if (this.props.animateFill) {
      this._timeouts.push(setTimeout(this.fill, this.props.animationDelay));
    }
  }
  componentDidUpdate(prevProps) {
    var _this$props$makeStyle2, _this$props2;
    if (this.props.animateFill && this.props.filled && this.props.filled !== prevProps.filled) {
      this.fill();
    }
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2, this.makeStyleProps());
  }
  componentWillUnmount() {
    this._animation && this._animation.cancel();
    this._timeouts.forEach(timeout => clearTimeout(timeout));
  }
  render() {
    var _this$props$styles, _this$props$styles2, _this$props$styles3;
    const animateFill = this.props.animateFill;
    const Icon = this.state.filled ? IconStarSolid : IconStarLightSolid;
    return _jsx("span", {
      "aria-hidden": "true",
      css: (_this$props$styles = this.props.styles) === null || _this$props$styles === void 0 ? void 0 : _this$props$styles.ratingIcon,
      ref: el => {
        this.ref = el;
      },
      children: this.state.filled && animateFill ? _jsx(Transition, {
        in: true,
        transitionOnMount: true,
        type: "scale",
        children: _jsx(Icon, {
          css: (_this$props$styles2 = this.props.styles) === null || _this$props$styles2 === void 0 ? void 0 : _this$props$styles2.icon
        })
      }) : _jsx(Icon, {
        css: (_this$props$styles3 = this.props.styles) === null || _this$props$styles3 === void 0 ? void 0 : _this$props$styles3.icon
      })
    });
  }
}, _RatingIcon.displayName = "RatingIcon", _RatingIcon.componentId = 'Rating.Icon', _RatingIcon.allowedProps = allowedProps, _RatingIcon.defaultProps = {
  animationDelay: 200,
  animateFill: false,
  filled: false,
  size: 'medium'
}, _RatingIcon)) || _class);
export default RatingIcon;
export { RatingIcon };